import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CustomLoginService } from '../../custom-login.service';
import { ToastService } from 'src/app/core/services/toaster.service';
import { Component, OnInit } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-countrieslist',
    templateUrl: './countrieslist.component.html',
    styleUrl: './countrieslist.component.scss',
    imports: [NgIf, NgFor, I18nModule]
})
export class CountrieslistComponent implements OnInit {
  private modalRef: NgbModalRef;
  headerText: string = '';
  footerText: string = '';
  countryList: any[] = [];
  bodyText: string = '';
  enableLoader: boolean = true;
  constructor(public activeModal: NgbActiveModal, public customLoginService: CustomLoginService, public toastService: ToastService) {

  }
  ngOnInit(): void {
    this.enableLoader = true;
    this.customLoginService.GetSMSCountries().subscribe(res => {
      this.enableLoader = false;
      if (res) {
        this.headerText = res.headerText;
        this.footerText = res.footerText;
        this.bodyText = res.bodyText;
        this.countryList = res.countryList;
      }
      else {
        this.toastService.show('Response not received as per format for SMS enabled countries, please contact support team');
      }

    }, err => {
      this.enableLoader = false;
      this.toastService.show('Error while getting SMS enabled countries, please contact support team');
    })

  }
  close() {
    this.activeModal.close();

  }
}